module.exports = __webpack_public_path__ + "app/kiss-user/modal-add-user-authorization-2YHI73oy.html";